import type { Background } from '@/api/types/background'
import type { BackgroundsPlacedFilter } from '@/lib/backgrounds/backgrounds-panel-settings'

/**
 * The Backgrounds tray's Placed filter, against the library response's `placedFlag` (the same
 * flag that drives the thumbnails' "Placed" badge): `'any'` keeps everything, `'yes'` only placed
 * backgrounds, `'no'` only unplaced ones. Same rule as ClikArt's `filterClikArtByPlaced`.
 */
export function filterBackgroundsByPlaced(
  backgrounds: Background[],
  filter: BackgroundsPlacedFilter
): Background[] {
  if (filter === 'any') return backgrounds

  const wantPlaced = filter === 'yes'

  return backgrounds.filter((background) => Boolean(background.placedFlag) === wantPlaced)
}
